import PropTypes from 'prop-types';
import React from 'react';
import SharedCard from './SharedCard';
import { sanitizeUrl } from '@braintree/sanitize-url';
import CoreSharedCard from './CoreSharedCard';

export default class PlaylistCard extends React.Component {
  static propTypes = {
    genericIncentive: PropTypes.object,
    learnerDashboard: PropTypes.bool,
    playlist: PropTypes.shape({
      image_url: PropTypes.string.isRequired,
      id: PropTypes.number.isRequired,
      incentive: PropTypes.shape({
        claim_message: PropTypes.string,
        incentive_activity: PropTypes.shape({
          status: PropTypes.string,
        }),
        incentive_message: PropTypes.string,
      }),
      name: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
      tagline: PropTypes.string,
    }).isRequired,
    program: PropTypes.shape({
      remove_content_images: PropTypes.bool,
      slug: PropTypes.string.isRequired,
    }),
    renderAsLegacy: PropTypes.bool,
  };


  render() {
    const { genericIncentive, learnerDashboard, playlist, program, renderAsLegacy } = this.props;
    const playlistUrl = sanitizeUrl(`/student/dashboard/${program.slug}/${playlist.slug}${window.location.search}`);
    const iconUrl = playlist.image_url ? playlist.image_url : '/assets/investments-logo.png';
    const CardComponent = renderAsLegacy ? SharedCard : CoreSharedCard;

    return (
      <CardComponent
        {...playlist}
        cardType="playlist"
        destinationUrl={playlistUrl}
        genericIncentive={genericIncentive}
        iconUrl={iconUrl}
        program={program}
        learnerDashboard={learnerDashboard}
      />
    );
  }
}
